'use strict';

import $ from 'jquery';
import util from '../../utils/util';
import offcanvasdialog from '../../components/offcanvasdialog';

export const initFlyin = () => {
    offcanvasdialog.removeDefaultContainers();
    offcanvasdialog.loadContainers(null, $('footer'));

    var flyinInstance = offcanvasdialog.init('flyin-link', {
        overlay: true,
        closeOnX: true,
        additionalClass: 'flyin-account-pages',
        headerStyle: 'over',
        beforeShow: function ($flyinContainer) {
            var lastTrigger = this.$lastTrigger.eq(0);
            var contentContainer = $('.ocd-flyin').find('.ocd-content');
            var $closeIcon = $(
                '<div class="ocd-close" tabindex="0" aria-label="Close" role="button"><i class="icon icon-close" aria-hidden="true" tabindex="-1"></i></div>'
            );

            $.ajax({
                url: util.appendParamToURL(lastTrigger.attr('href'), 'format', 'ajax')
            }).done(function (data) {
                contentContainer.html(data);
                contentContainer.append($closeIcon);
                contentContainer.focus();

                $closeIcon.on('click', function (event) {
                    flyinInstance.hide();
                });
            });
        }
    });
};
